<template>
    <div id="company-profile">
        <header class="company-intro">
            <div class="intro-box">
                <p class="intro-cnt">{{data.introduce?data.introduce:'该物流公司暂时没有简介'}}</p>
            </div>
            <div class="photo-box"><img class="intro-photo" :src="data.logo?data.logo:require('../../assets/company.jpg')" alt=""></div>
        </header>
        <van-search v-model="searchKey" placeholder="请输入网点名或地址" show-action>
            <div slot="action" @click="onSearch">搜索</div>
        </van-search>

        <van-list v-model="loading" :finished="finished" @load="onLoad" class="line-list">
            <van-cell class="line-item" v-for="item in lineList" :key="item.id">
                <h3 class="item-name">{{item.organName}}</h3>
                <p class="item-phone"><span style="flex:1;">联系电话：<a :href="'tel:'+item.contactPhone" class="phone-number">{{item.contactPhone}}</a></span><span style="flex:1;">客户电话：<a :href="'tel:'+item.customerPhone" class="phone-number">{{item.customerPhone}}</a></span></p>
                <p class="item-address">地址：{{item.contactAddress}}</p>
            </van-cell>
        </van-list>

    </div>
</template>

<script>
export default {
  name: "CompanyProfile",
  data() {
    return {
      data: {},
      lineList: [],
      searchKey: "",
      loading: false,
      finished: false,
      pageNum: 1
    };
  },
  created() {
    this.ready();
  },
  methods: {
    ready() {
      let params = {
        params: {
          logisticsCompanyId: this.$route.params.id
        }
      };
      this.$axios({
        url: "worker/logisid/introduce",
        method: "post",
        header: {
          "content-type": "application/json;charset:utf-8"
        },
        data: params
      }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data;
          this.data = data;
        }
      });
    },
    onLoad() {
      let params = {
        page: {
          pageNum: this.pageNum,
          pageSize: 10
        },
        params: {
          logisticsCompanyId: this.$route.params.id,
          name: this.searchKey
        }
      };
      this.$axios({
        url: "merchant/organ/line",
        method: "post",
        header: {
          "content-type": "application/json;charset=utf-8"
        },
        data: params
      }).then(res => {
        if (res.data.code === 200) {
          this.pageNum++;
          let data = res.data.data;
          this.lineList = this.lineList.concat(data.list);
          this.loading = false;
          this.finished = !data.hasNextPage;
        }
      });
    },
    onSearch() {
      this.pageNum = 1;
      this.finished = false;
      this.lineList = [];
      this.loading = true;
      let params = {
        page: {
          pageNum: this.pageNum,
          pageSize: 10
        },
        params: {
          logisticsCompanyId: this.$route.params.id,
          name: this.searchKey
        }
      };
      this.$axios({
        url: "merchant/organ/line",
        method: "post",
        header: {
          "content-type": "application/json;charset=utf-8"
        },
        data: params
      }).then(res => {
        if (res.data.code === 200) {
          this.pageNum++;
          let data = res.data.data;
          this.lineList = data.list;
          this.loading = false;
          this.finished = !data.hasNextPage;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#company-profile {
  .company-intro {
    display: flex;
    background-color: #fff;
    padding: 0 0.7rem;
    .intro-box {
      flex: 1;
      box-sizing: border-box;
      padding: 1rem 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
    }
    .photo-box {
      width: 3.2rem;
      padding: 1rem 0;
      .intro-photo {
        width: 100%;
      }
    }
  }
  .line-list {
    .line-item {
      .item-name {
        font-weight: 600;
        font-size: 20px;
        margin-bottom: 0.3rem;
      }
      .item-phone {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.125rem;
        .phone-number {
          color: #00a5e0;
        }
      }
    }
  }
}
</style>
